import * as DialogPrimitive from "@radix-ui/react-dialog"

import React, { forwardRef } from "react"

import { Drawer as DrawerPrimitive } from "vaul"
import { cn } from "../../utils/cn"
import { useMediaQuery } from "usehooks-ts"
import { useTranslation } from "react-i18next"

export const DialogContent = forwardRef<
    HTMLDivElement,
    React.ComponentPropsWithoutRef<"div"> & { dismissible?: boolean; hideClose?: boolean }
>(({ children, className, dismissible = true, hideClose = false, ...props }, forwardedRef) => {
    const { t } = useTranslation("shared")
    const isDesktop = useMediaQuery("(min-width: 768px)", { initializeWithValue: false })

    if (isDesktop)
        return (
            <DialogPrimitive.Portal>
                <DialogPrimitive.Overlay className="fixed inset-0 bottom-0 left-0 right-0 top-0 z-[9] grid place-items-center overflow-y-auto bg-[#ddd]/85 px-5 py-6 lg:px-8 lg:py-10">
                    <DialogPrimitive.Content
                        className={cn(
                            "relative z-[9] box-content max-w-[1008px] bg-white p-10 shadow-lg rounded-lg lg:p-16",
                            className
                        )}
                        {...props}
                        ref={forwardedRef}
                    >
                        <div className="w-full">{children}</div>
                        {dismissible && !hideClose && (
                            <DialogPrimitive.Close className="absolute right-5 top-5 text-dark-grey">
                                <i className="lavita-icon text-xl leading-none"></i>
                                <span className="sr-only">{t("close")}</span>
                            </DialogPrimitive.Close>
                        )}
                    </DialogPrimitive.Content>
                </DialogPrimitive.Overlay>
            </DialogPrimitive.Portal>
        )

    return (
        <DrawerPrimitive.Portal>
            <DrawerPrimitive.Overlay className="fixed inset-0 z-[9] bg-black/50" />
            <DrawerPrimitive.Content
                className="fixed bottom-0 left-0 right-0 z-[9] flex h-fit max-h-[80%] rounded-t-lg bg-white p-3.5 pb-0 outline-none"
                {...props}
                ref={forwardedRef}
            >
                <div className="relative flex flex-1 flex-col rounded-t-lg bg-white">
                    {dismissible && (
                        <div aria-hidden className="mx-auto mb-10 h-1 w-15 shrink-0 rounded-full bg-border-tide" />
                    )}
                    <div className={cn("flex-1 overflow-y-auto px-[11px] pb-10", { "mt-6.25": !dismissible })}>
                        {children}
                    </div>
                    {dismissible && !hideClose && (
                        <DrawerPrimitive.Close className="absolute right-1.5 top-1.5 text-dark-grey">
                            <i className="lavita-icon text-xl leading-none"></i>
                            <span className="sr-only">{t("close")}</span>
                        </DrawerPrimitive.Close>
                    )}
                </div>
            </DrawerPrimitive.Content>
        </DrawerPrimitive.Portal>
    )
})

export const Dialog = DrawerPrimitive.Root

export const DialogTrigger = DialogPrimitive.Trigger

export const DialogTitle = DialogPrimitive.Title
